import React, { Component } from 'react';
import ModalActionCreator from 'action_creators/modal';

import './PricingModal.scss';

class PricingModal extends Component {
  constructor(props) {
    super(props);

    const { id } = props.tour;
    const { types } = props.tour.pricing;
    const selections = {};

    types.forEach((type) => {
      selections[type.id] = 0;
    });

    this.state = {
      tourId: id,
      selections,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setupSelections(nextProps);
  }

  setupSelections = (props) => {
    const { id } = props.tour;
    const { types } = props.tour.pricing;

    if (this.state.tourId !== id) {
      const selections = {};
      types.forEach((type) => {
        selections[type.id] = 0;
      });

      this.setState({
        tourId: id,
        selections,
      });
    }
  };

  decrementSelection = ({ id }) => {
    const { selections } = this.state;
    if (selections[id] !== 0) selections[id] -= 1;
    this.setState({
      selections,
    });
  };

  incrementSelection = ({ id }) => {
    const { selections } = this.state;
    selections[id] += 1;
    this.setState({
      selections,
    });
  };

  selectionsValid = (selections) => {
    let sum = 0;
    Object.values(selections).forEach((count) => {
      sum += count;
    });
    return sum > 0;
  };

  continueClicked = () => {
    const { tourId, selections } = this.state;
    const checkoutData = {
      tourId,
      selections,
    };

    this.props.submitPricingSelection(checkoutData);
    ModalActionCreator.hide();
  };

  renderPricingSelection = () => {
    const { pricing } = this.props.tour;

    const selectors = pricing.types.map((type) => (
      <div className="pricingType" key={type.id}>
        <div className="details">
          <div className="name">{type.name}</div>
          <div className="description">
            {type.description} @ {this.props.tour.currency}
            {type.price}
          </div>
        </div>
        <div className="selector">
          <div
            className="selectorButton left"
            onClick={() => this.decrementSelection(type)}
          >
            &#8722;
          </div>
          <div className="quantity">{this.state.selections[type.id]}</div>
          <div
            className="selectorButton right"
            onClick={() => this.incrementSelection(type)}
          >
            &#43;
          </div>
        </div>
      </div>
    ));

    return <div className="pricingSelection">{selectors}</div>;
  };

  render() {
    const { name } = this.props.tour;

    return (
      <div className="pricingModal">
        <div className="heading">Gift Certificate: {name}</div>
        {this.renderPricingSelection()}
        <div
          className={`continueButton ui fluid huge button anygreen ${
            !this.selectionsValid(this.state.selections) ? 'disabled' : null
          }`}
          onClick={this.continueClicked}
        >
          Continue
        </div>
      </div>
    );
  }
}

export default PricingModal;
